var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTopic4Active(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 31,
    height: 31,
    rx: 3,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.86771 20.2H23.4865V21.9H7.86771V20.2ZM23.9282 12.148C23.8111 11.8036 23.5593 11.5189 23.2279 11.3565C22.8966 11.1941 22.513 11.1672 22.1615 11.2818L18.2802 12.55L11.3386 10L9.60313 10.85L14.8094 14.25L11.3386 15.95L7.86771 14.25L7 15.1L10.4708 18.5L23.0934 13.8633C23.4321 13.7387 23.7083 13.4904 23.864 13.1705C24.0196 12.8506 24.0426 12.4841 23.9282 12.148Z",
    fill: "#2071F1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopic4Active);
export default __webpack_public_path__ + "static/media/topic4_active.1dede58dfec7d88728d160a4bc72a0f9.svg";
export { ForwardRef as ReactComponent };